<template>
    <div class="img-wrap module-wrap" :id="target" v-if="has_data" :data-spm="spm">
        <a :href="item.link ? item.link : 'javascript:;'" class="link" :data-log-content-ev="item.stat_flag" @click.prevent="clickItemHandler(item)" ref=img>
            <img ref="img_bg" class="image" v-lazy="item.imageUrl">
            <footer :class="img_info" v-show="show_info">
                <h3 class="tt">{{item.title}}</h3>
            </footer>   
        </a>
    </div>
</template>
<script>
import Util from '../_utils/util';
import nativeUtil from '../_utils/native-util.js'

const thinRatio = 1/6;
export default {
    props: {
        target: {
            default: '',
            type: String
        },
        spm:{
            default: '',
            type: String
        },
        data: {
            default : {},
            type: [ Object, Array ]
        },
        findex: {
            default: '',
            type: [String, Number]
        }
    },
    data(){
        return {
            show_info: false,
            isThinImg: false
        }
    },
    methods: {
        getImgNaturalDimensions(img, callback) {
            var nWidth = 0 , nHeight = 0, image;
            if(!img){
                callback(nWidth, nHeight);
                return;
            }
            if (img.naturalWidth) { // 现代浏览器
                nWidth = img.naturalWidth
                nHeight = img.naturalHeight
                callback(nWidth, nHeight)
            } else { // IE6/7/8
                img.onload = function() {
                    callback(img.width, img.height)
                }
            }
        },
        clickItemHandler(data) {
            const url = this.$refs.img.getAttribute('href')
            nativeUtil.openContent(url, data)
        }
    },
    mounted(){
        let that = this; 
        let img_bg = this.$refs.img_bg;
        this.getImgNaturalDimensions(img_bg, (width, height) => {
            let ratio;
            if(width > 0 && height > 0){
                ratio = height / width;
                if(ratio > thinRatio){
                    that.isThinImg = false;
                }else{
                    that.isThinImg = true;
                }
            }
            that.show_info = true;
        });
        this.$nextTick(() => {
            let dom = document.getElementById(this.target);
            if(dom != null){
                 let imgList = dom.querySelectorAll('a[data-log-content-ev]');
                 this.$emit('mounted', imgList);
            }
        })
    },
    computed: {
        item(){
            let item = {};
            let subId = window.subData.id;
            let stat_flag = `m-${subId}_subpics_${this.findex}`;
            if(this.data[0]){
                item = this.data[0];
                item.stat_flag = stat_flag;
                if(item.link){
                    item.link = Util.addQueryArgs(item.link, {
                        _f: stat_flag
                    }); 
                } 
            }
            return item;
        },
        has_data(){
            return this.data.length > 0 && this.item.imageUrl;
        },
        img_info(){
            return this.isThinImg ? 'thin-info' : 'info';
        }
    }
}
</script>
<style lang="less">
    .img-wrap{
        position: relative;
        margin: 10px 13px;
        overflow: hidden;
        font-size: 18px; /*no*/
        .image{
            position: relative;
            &[src$="preload.png"]{
                height: 174.5px;
            }
        }
        // 窄图-特殊样式
        .thin-info{
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 70%;
            left: 0;
            bottom: 0;
            background: linear-gradient(rgba(0, 0, 0, 0), rgba(57, 57, 57, 0.85));
            .tt{
                position: absolute;
                box-sizing: border-box;
                padding-left: 9px;
                padding-right: 6px;
                width: 100%;
                bottom: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #fff;
                font-weight: bold;
            }
        }
        .info{
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 80px;
            left: 0;
            bottom: 0;
            background: linear-gradient(rgba(0, 0, 0, 0), rgba(57, 57, 57, 0.85));
            .tt{
                position: absolute;
                box-sizing: border-box;
                padding-left: 9px;
                padding-right: 6px;
                bottom: 12px;
                font-size: 18px;/*no*/
                line-height: 1.3em;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                display: box;
                -webkit-box-orient: vertical;
                color: #fff;
                font-weight: bold;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/VImage.vue